<template>
  <v-data-table dense
                :headers="headers"
                :items="dailySafetyObservations"
                multi-sort
                :sort-by="sortBy"
                :sort-desc="true"
                show-expand
                single-expand
                :group-by="groupBy"
                no-data-text="No Safety Observations"
                :mobile-breakpoint="dataTableMobileBreakpoint"
                :search="search">
    <template v-slot:top>
      <div class="d-flex text-start pa-4">
        <span class="headline primary--text font-weight-medium">
          <v-icon class="primary--text" left>mdi-comment-alert</v-icon>Safety Observations
        </span>
        <v-spacer></v-spacer>
        <v-text-field class="pa-0 ma-0"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details></v-text-field>
      </div>
    </template>
    <template v-slot:group.header="props">
      <td class="text-start pa-2 font-weight-medium"
          :colspan="props.headers.length">
        <v-tooltip bottom color="black">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              <v-icon left>mdi-ferry</v-icon>
              {{ props.group }}
            </span>
          </template>
          Vessel {{ props.group }}
        </v-tooltip>
      </td>
    </template>
    <template v-slot:item.observationDateTimeLt="{ item }">
      <span>{{ item.observationDateTimeLt | removeTAndSecondsAndFormatDate }}</span>
    </template>
    <template v-slot:item.photoFileNames="{ item }">
      <span>{{getPhotoCount(item)}}</span>
    </template>
    <template v-slot:item.description="{ item }">
      <div class="text-truncate" style="max-width: 20rem">
        {{ item.description }}
      </div>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="text-start pa-4">
        <div class="my-2">
          <span class="font-weight-bold">Full description:</span>
          <div>{{ item.description }}</div>
        </div>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';

export default {
  name: 'DailyVoyageReportVoyageTable',
  mixins: [ResponsiveSizeHelperMixin],
  props: {
    dailySafetyObservations: { type: Array, required: true }
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Observation Date', value: 'observationDateTimeLt' },
        { text: 'Reported By', value: 'reporterName' },
        { text: 'Location', value: 'location' },
        { text: 'Description', value: 'description' },
        { text: 'Non-conformance Type', value: 'nonConformanceType' },
        { text: 'Pictures', value: 'photoFileNames' },
        { text: '', value: 'data-table-expand' },
      ],
      sortBy: ['vesselName', 'observationDateTimeLt'],
      groupBy: 'voyageReport.vesselName',
    };
  },
  methods: {
    getPhotoCount(safetyObservation) {
      return safetyObservation.photoFileNames ? safetyObservation.photoFileNames.length : 0;
    }
  }
};
</script>
